import React, { useState, useEffect, createContext, useReducer, useContext } from 'react';

import { getMediaDeviceInfo, initialVCState } from './helpers';

import { INIT_MEDIA_INFO } from './constants';

export function useDevices() {
  const [deviceInfo, setDeviceInfo] = useState(INIT_MEDIA_INFO);

  useEffect(() => {
    const getDevices = () => getMediaDeviceInfo().then(devices => setDeviceInfo(devices));
    navigator.mediaDevices.addEventListener('devicechange', getDevices);
    getDevices();

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', getDevices);
    };
  }, []);

  return deviceInfo;
}

/** The video conference context/state */

export const VCControlAction = Object.freeze({
  SetAudioInput: 1,
  SetVideoInput: 2,
  SetAudioOutput: 3,
  SetMultipleDeviceId: 4,
})

function VCControlReducer(state, action) {
  switch(action.type) {
    case VCControlAction.SetAudioInput:
      return { ...state, activeAudioInputId: action.id };
    case VCControlAction.SetVideoInput:
      return { ...state, activeVideoInputId: action.id };
    case VCControlAction.SetAudioOutput:
      return { ...state, activeAudioOutputId: action.id };
    case VCControlAction.SetMultipleDeviceId:
      return { ...state, ...action.ids };
  }
}

const VCControlContext = createContext();

export function VCControlProvider (props) {
  const [VCControlState, VCControlDispatch] = useReducer(VCControlReducer, initialVCState)
  return (
    <VCControlContext.Provider value={{VCControlState, VCControlDispatch}}>
      {props.children}
    </VCControlContext.Provider>
  );
}

/**
  a control state store.
  It contains the following state and dispatch method:
  VCControlState = {
    activeAudioInputId,
    activeVideoInputId,
    activeAudioOutputId,
  }
  VCControlDispatch:
    To set single active device id: ({action: VCControlAction, id: newActiveId})
    To set multiple active device id: ({action: VCControlAction.SetMultipleDeviceId, ids: {XXid: id}})
 */
export function useVCControl() {
  const context = useContext(VCControlContext);
  if (!context) {
    throw new Error('useVCControl must be used within the VCControlProvider')
  }
  return context;
}